import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgUpload() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.826 3c-2.74 0-4.578 1.263-5.698 2.813A8.22 8.22 0 004.7 9.343a4.661 4.661 0 00-1.997 1.043c-.957.848-1.648 2.165-1.7 4.009-.048 1.746.62 3.133 1.467 4.079.421.47.893.84 1.357 1.096.447.247.959.428 1.453.428h13.078a4.402 4.402 0 002.87-1.015c1-.83 1.717-2.177 1.77-4.152.054-1.998-.643-3.406-1.632-4.316a5.01 5.01 0 00-2.11-1.148c-.221-1.105-.726-2.464-1.653-3.648C16.416 4.204 14.548 3 11.826 3z",
      fill: "#fff"
    }, void 0), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M6.128 5.813C7.248 4.263 9.086 3 11.826 3c2.722 0 4.59 1.204 5.776 2.719.927 1.184 1.431 2.543 1.652 3.648a5.01 5.01 0 012.111 1.148c.989.91 1.686 2.318 1.632 4.316-.053 1.975-.77 3.321-1.77 4.152a4.402 4.402 0 01-2.87 1.015H13v-7.294l2.341 2.049a1 1 0 001.318-1.506l-4-3.5a1 1 0 00-1.318 0l-4 3.5a1 1 0 001.318 1.506L11 12.703v7.295H5.279c-.494 0-1.006-.181-1.453-.428a5.275 5.275 0 01-1.357-1.096c-.847-.946-1.515-2.333-1.466-4.08.05-1.843.742-3.16 1.7-4.008a4.661 4.661 0 011.996-1.043 8.22 8.22 0 011.43-3.53z",
      fill: "currentColor"
    }, void 0)]
  }), void 0);
}

export default SvgUpload;